import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["panel", "trigger"]

    connect() {
        this.panelTargets.forEach(p => {
            p.style.maxHeight = "0px"
            p.style.opacity = "0"
            p.dataset.state = "closed"
        })
        this.triggerTargets.forEach(t => t.setAttribute("aria-expanded", "false"))
    }

    toggle(event) {
        const trigger = event.currentTarget
        const panel = trigger.nextElementSibling
        if (!panel) return

        const isClosed = panel.dataset.state !== "open"
        trigger.setAttribute("aria-expanded", isClosed ? "true" : "false")
        trigger.classList.toggle("active", isClosed)

        if (isClosed) this.open(panel)
        else this.close(panel)
    }

    open(panel) {
        if (panel.dataset.animating === "true") return
        panel.dataset.animating = "true"
        panel.dataset.state = "opening"

        panel.style.display = "block"
        panel.style.opacity = "0"
        panel.style.maxHeight = "0px"

        requestAnimationFrame(() => {
            const h = panel.scrollHeight
            panel.style.maxHeight = h + "px"
            panel.style.opacity = "1"

            const done = () => {
                panel.removeEventListener("transitionend", done)
                panel.dataset.animating = "false"
                panel.dataset.state = "open"
                // optionnel: verrouiller la hauteur auto
                panel.style.maxHeight = "none"
            }
            panel.addEventListener("transitionend", done, { once: true })
        })
    }

    close(panel) {
        if (panel.dataset.animating === "true") return
        panel.dataset.animating = "true"
        panel.dataset.state = "closing"

        const current = panel.scrollHeight
        panel.style.maxHeight = current + "px"
        panel.style.opacity = "1"

        requestAnimationFrame(() => {
            panel.style.maxHeight = "0px"
            panel.style.opacity = "0"
            const done = () => {
                panel.removeEventListener("transitionend", done)
                panel.dataset.animating = "false"
                panel.dataset.state = "closed"
                panel.style.display = "block"
            }
            panel.addEventListener("transitionend", done, { once: true })
        })
    }
}
